import script from "./AppAddressField.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAddressField.vue?vue&type=script&setup=true&lang=ts"

import "./AppAddressField.vue?vue&type=style&index=0&id=a4db74e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4db74e0"]])

export default __exports__